import { sendClassifiedAnalytics } from "@/api/sendClassifiedAnalytics";
import { CLASSIFIED_ANALYTICS_PATH } from "@/constants";
import { useClassifiedId } from "@/contexts/classified";
import { useBrandUrl } from "@/hooks";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
import { useCallback } from "react";
export const useClassifiedAnalytics = () => {
    const analyticsUrl = useBrandUrl({ endpoint: CLASSIFIED_ANALYTICS_PATH });
    const classifiedId = useClassifiedId();
    const isPreviewMode = useIsPreviewMode();
    const sendClassifiedAnalyticsEvent = useCallback((eventType, classifiedIdOverride) => {
        if (!isPreviewMode) {
            const usedClassifiedId = classifiedIdOverride || classifiedId;
            const eventData = {
                type: eventType,
                data: { classifiedId: usedClassifiedId },
            };
            // @ts-ignore
            sendClassifiedAnalytics(analyticsUrl, eventData);
        }
    }, [isPreviewMode, classifiedId, analyticsUrl]);
    return { sendClassifiedAnalyticsEvent };
};
